export const OPTION_LISTS_ENABLED = true;

export function areOptionListsEnabled() {
    return OPTION_LISTS_ENABLED;
}